import React from 'react';
import BaseAlert, { BaseAlertProps } from 'libs/core-components/Alert/BaseAlert';
import colors from 'settings/colors';
import styled from 'styled-components';
import SuccessIcon from 'common/Icon/semantic/SuccessIcon';

export const StyledSuccessAlert = styled(BaseAlert)`
    background: ${colors.semantic.success};
    color: white;
`;

type SuccessAlertProps = Omit<BaseAlertProps, 'icon'>;

export default function SuccessAlert({ children, ...rest }: SuccessAlertProps) {
    return (
        <StyledSuccessAlert icon={<SuccessIcon />} {...rest}>
            {children}
        </StyledSuccessAlert>
    );
}
